import { useCallback, useEffect, useState } from 'react';

const DefaultNetworkQuality = 5;

function useNetworkQuality({ zoomClient, userId }) {
  const [networkQuality, setNetworkQuality] = useState(DefaultNetworkQuality);

  const networkQualityChange = useCallback(
    payload => {
      if (payload.userId !== userId) return;
      setNetworkQuality(payload.level);
    },
    [userId],
  );

  useEffect(() => {
    if (!zoomClient) return;
    zoomClient.on('network-quality-change', networkQualityChange);
    return () => {
      zoomClient.off('network-quality-change', networkQualityChange);
    };
  }, [networkQualityChange, zoomClient]);

  return {
    networkQuality,
  };
}

export default useNetworkQuality;
